/**
 *
 * Asynchronously loads the component for NotificationBar
 *
 */

import { lazyLoad } from 'utils/loadable';

export const NotificationBar = lazyLoad(
  () => import('./index'),
  module => module.NotificationBar,
);
